var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopIcon = function SvgStopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#stopIcon_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 20,
    y: 16,
    fill: "url(#stopIcon_svg__b)",
    rx: 32,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#stopIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 56,
    height: 60,
    x: 24,
    y: 20
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#stopIcon_svg__d)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 8,
    filter: "url(#stopIcon_svg__e)",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA8A8",
    fillOpacity: 0.6,
    d: "M32 60.189q0 1.345.943 2.29l4.579 4.578q.942.943 2.29.943 1.345 0 2.289-.943L52 57.158l9.899 9.9q.943.942 2.29.942 1.345 0 2.29-.943l4.578-4.579q.943-.942.943-2.29 0-1.346-.943-2.289L61.158 48l9.9-9.899q.942-.943.942-2.29 0-1.345-.943-2.29l-4.579-4.578Q65.536 28 64.188 28q-1.345 0-2.289.943L52 38.842l-9.899-9.9Q41.158 28 39.811 28q-1.345 0-2.29.943l-4.578 4.579q-.943.942-.943 2.29 0 1.345.943 2.289L42.842 48l-9.9 9.899q-.942.943-.942 2.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.25,
    d: "M39.812 28.5c-.767 0-1.403.262-1.937.796l-4.58 4.579c-.533.534-.795 1.17-.795 1.937 0 .766.263 1.402.796 1.935L43.549 48 33.296 58.253c-.533.533-.796 1.169-.796 1.935 0 .767.262 1.403.796 1.937l4.579 4.58c.534.533 1.17.795 1.937.795.766 0 1.402-.263 1.935-.796L52 56.451l10.253 10.253c.533.534 1.169.796 1.936.796s1.402-.262 1.936-.796l4.58-4.579c.533-.534.795-1.17.795-1.937 0-.766-.263-1.402-.796-1.935L60.451 48l10.253-10.253c.534-.533.796-1.169.796-1.935 0-.767-.262-1.403-.796-1.937l-4.579-4.58c-.534-.533-1.17-.795-1.936-.795-.767 0-1.402.262-1.936.796L52 39.549 41.747 29.296c-.533-.534-1.169-.796-1.935-.796Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "stopIcon_svg__a",
    width: 104,
    height: 104,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_966_16275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_966_16275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stopIcon_svg__c",
    width: 56,
    height: 60,
    x: 24,
    y: 20,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_966_16275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_966_16275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stopIcon_svg__e",
    width: 56,
    height: 60,
    x: 24,
    y: 20,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_966_16275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_966_16275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stopIcon_svg__b",
    x1: 52,
    x2: 52,
    y1: 16,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3434"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stopIcon_svg__d",
    transform: "translate(-24 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 60.189q0 1.345.943 2.29l4.579 4.578q.942.943 2.29.943 1.345 0 2.289-.943L52 57.158l9.899 9.9q.943.942 2.29.942 1.345 0 2.29-.943l4.578-4.579q.943-.942.943-2.29 0-1.346-.943-2.289L61.158 48l9.9-9.899q.942-.943.942-2.29 0-1.345-.943-2.29l-4.579-4.578Q65.536 28 64.188 28q-1.345 0-2.289.943L52 38.842l-9.899-9.9Q41.158 28 39.811 28q-1.345 0-2.29.943l-4.578 4.579q-.943.942-.943 2.29 0 1.345.943 2.289L42.842 48l-9.9 9.899q-.942.943-.942 2.29"
  })))));
};
export default SvgStopIcon;